import { Link, useParams } from "react-router-dom";
import React, { useState } from "react";
import "../../assets/css/--component-login.css";
import logo from "../../assets/images/mains-logo.png";
import resetSuccess from "../../assets/images/reset-success.png";
import { resetPassword } from "../../helper/backend-methods";

function ResetPassword(props) {
  let params = useParams();
  const token = params.token;
  const guid = params.guid;
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [userpassword, setUserpassword] = useState("");
  const [userpassword2, setUserpassword2] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [serverError, setServerError] = useState("");
  const [errors, setErrors] = useState({ userpassword: "", userpassword2: "" });
  const [loading, setLoading] = useState(false);

  const validateSubmit = (e) => {
    e.preventDefault();
    const errors = { userpassword: "", userpassword2: "" };
    let flag = false;
    if (!userpassword) {
      errors.userpassword = "Please provide a valid password";
      flag = true;
    } else if (!/^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?#&]{8,}$/.test(userpassword.trim())) {
      errors.userpassword = "Password must contain at least 1 uppercase letter, 1 number, and be at least 8 characters long";
      flag = true;
    }
    if (!userpassword2) {
      errors.userpassword2 = "Please provide a valid password";
      flag = true;
    } else if (userpassword2.replaceAll(/\s/g, "").length < 6) {
      errors.userpassword2 = "Password must have at minimum 6 characters";
      flag = true;
    } else if (userpassword !== userpassword2) {
      errors.userpassword2 = "Passwords do not match. Please try again!";
      flag = true;
    }
    setErrors(errors);
    if (!flag) {
      setLoading(true);
      resetPassword({ token: token, guid: guid, password: userpassword })
        .then(({ data }) => {
          if (data.Status) {
            setServerError("Your password has been updated. Please sign-in to continue.");
            setIsSuccess(true);
          } else {
            setServerError(data.Message);
            setLoading(false);
          }
        })
        .catch((e) => {
          setServerError("Something went wrong. Please try again!");
          setLoading(false);
          console.log(e);
        });
    }
  };

  return (
    <section id="login" className="forgot-reset-password">
      <div className="logo-img text-center mb-5">
        <img src={logo} alt="Main Country Grill and Store" className="form-logo" />
      </div>
      <div className="wrapper" style={{ width: "100%" }}>
        <div className="login-form-wrapper">
          {!isSuccess ? (
            <form onSubmit={validateSubmit}>
              <h1 className="form-title text-center mb-3">Set-up Password</h1>
              <p className="text-center fs-18 text-gray-600">Your new password must be different from previously used password.</p>
              {serverError.length ? (
                <p className="text-left txt-danger fs-16 fw-400">
                  <i className="ri-error-warning-line"></i> {serverError}
                </p>
              ) : (
                <></>
              )}
              <div className="form-group has-icon">
                <label htmlFor="userpassword">
                  Enter New Password<span className="txt-danger">*</span>
                </label>
                <input
                  readOnly={isSuccess}
                  id="userpassword"
                  type={isVisible ? "text" : "password"}
                  name="userpassword"
                  onChange={(e) => {
                    setUserpassword(e.target.value.replaceAll(/\s/g, "").slice(0, 30));
                  }}
                  value={userpassword}
                  placeholder="*****************"
                  className={`${errors.userpassword || errors.serverError ? "bd-danger" : ""}`}
                />
                <button
                  onClick={() => {
                    setIsVisible(!isVisible);
                  }}
                  type="button"
                >
                  {isVisible ? <i className="ri-eye-off-line"></i> : <i className="ri-eye-line"></i>}
                </button>
                <span className="fs-14 fw-400 d-block mt-2 login-info font-inter text-gray-600">
                  Must contain 1 uppercase letter, 1 number, min 8 characters.
                </span>
                {errors.userpassword ? <span className="txt-danger fs-12 fw-400">{errors.userpassword}</span> : null}
              </div>
              <div className="form-group has-icon">
                <label htmlFor="userpassword2">
                  Confirm Password <span className="txt-danger">*</span>
                </label>
                <input
                  readOnly={isSuccess}
                  id="userpassword2"
                  type={isVisible2 ? "text" : "password"}
                  name="userpassword2"
                  onChange={(e) => {
                    setUserpassword2(e.target.value.replaceAll(/\s/g, "").slice(0, 30));
                  }}
                  value={userpassword2}
                  placeholder="*****************"
                  className={`${errors.userpassword2 || errors.serverError ? "bd-danger" : ""}`}
                />
                <button
                  onClick={() => {
                    setIsVisible2(!isVisible2);
                  }}
                  type="button"
                >
                  {isVisible2 ? <i className="ri-eye-off-line"></i> : <i className="ri-eye-line"></i>}
                </button>
                {errors.userpassword2 ? <span className="txt-danger fs-12 fw-400">{errors.userpassword2}</span> : null}
              </div>
              <div className="form-group mt-4">
                <button type="submit" disabled={loading} className="btn btn-primary w-100 rounded-5 border-0">
                  {loading ? "Please Wait..." : "RESET PASSWORD"}
                </button>
              </div>
            </form>
          ) : (
            <form>
              <img src={resetSuccess} alt="EmailLogo" className="form-logo" />
              <h1 className="form-title text-center mb-3 fs-30 text-black">Password Set-up Successful</h1>
              <p className="text-center text-gray-600 fs-18 mb-4">Your password has been successfully reset. Click below to login.</p>
              <Link to={"/login"} className="btn btn-primary w-100 rounded-5 border-0 d-flex text-white fw-700">
                {" "}
                LOGIN
              </Link>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
export default ResetPassword;
